import { render, staticRenderFns } from "./GoalItemCreateContainer.vue?vue&type=template&id=728ec2e6&"
import script from "./GoalItemCreateContainer.vue?vue&type=script&lang=js&"
export * from "./GoalItemCreateContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports